const login = {
  root: "Connection",
  sign_in_here: "Log in here",
  welcome: "Welcome to the platform👋",
};
export default login;
